import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["canvas"];

  static values = {
    ages: { type: Array, default: [] },
  };

  connect() {
    this.isDefault = true;
    this.chartInstance;
    this.displayableAges = [
      [14, 24],
      [25, 34],
      [35, 44],
      [45, 54],
      [55, 64],
      [65, 1e6],
    ];
    this.setupExistingAges();
    this.setupChart();
    window.addEventListener("filterAge", (e) => {
      this.displayAges(e.detail.age);
    });
  }

  setupChart() {
    const getKeyOfRange = (ageRange) => {
      if (ageRange[1] === 1e6) {
        return `${ageRange[0]}+`;
      } else {
        return `${ageRange[0]}-${ageRange[1]}`;
      }
    };

    let chartValues = {};

    this.displayableAges.forEach((ageRange) => {
      chartValues[getKeyOfRange(ageRange)] = 0;
    });

    this.agesValue.forEach((age) => {
      this.displayableAges.forEach((ageRange) => {
        if (ageRange[0] <= age && ageRange[1] >= age) {
          chartValues[getKeyOfRange(ageRange)]++;
        }
      });
    });
    Chart.register(ChartDataLabels);

    if (this.canvasTarget) {
      var ctx = this.canvasTarget;
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      this.chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.displayableAges.map((ageRange) =>
            getKeyOfRange(ageRange)
          ),
          datasets: [
            {
              label: "",
              data: Object.keys(chartValues).map((key) => chartValues[key]),
              backgroundColor: ["#E8443F"],
              maxBarThickness: 24,
            },
          ],
        },
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false,
            },
            tooltips: {
              enabled: false,
            },
          },
        },
      });
    }
  }

  setupExistingAges() {
    let checkboxes = Array.from(
      document.querySelectorAll(".checkbox input[type='checkbox']")
    );
    checkboxes.shift();

    checkboxes = checkboxes.filter((checkbox) => !checkbox.checked);
    if (checkboxes.length === 6) {
      return;
    }

    checkboxes.forEach((element) => {
      let parsedAge;
      if (element.value === "65") {
        parsedAge = [65, 1e6];
      } else if (element.value !== undefined) {
        parsedAge = [
          parseInt(element.value.split("-")[0]),
          parseInt(element.value.split("-")[1]),
        ];
      }

      if (
        this.displayableAges.some(
          (displayableAge) =>
            displayableAge[0] === parsedAge[0] &&
            displayableAge[1] === parsedAge[1]
        )
      ) {
        this.displayableAges = this.displayableAges.filter(
          (displayableAge) =>
            displayableAge[0] !== parsedAge[0] ||
            displayableAge[1] !== parsedAge[1]
        );
      } else {
        this.displayableAges.push(parsedAge);
      }
    });
    this.displayableAges = this.displayableAges;
  }

  displayAges(age) {
    let checkboxes = Array.from(
      document.querySelectorAll(".checkbox input[type='checkbox']")
    );
    checkboxes.shift();

    checkboxes = checkboxes.filter((checkbox) => !checkbox.checked);
    let parsedAge;

    if (age === 65) {
      parsedAge = [65, 1e6];
    } else if (age !== undefined) {
      parsedAge = [parseInt(age.split("-")[0]), parseInt(age.split("-")[1])];
    }

    if (age === "all") {
      this.displayableAges = [
        [14, 24],
        [25, 34],
        [35, 44],
        [45, 54],
        [55, 64],
        [65, 1e6],
      ];
    } else {
      if (this.isDefault && checkboxes.length === 5) {
        this.displayableAges = [];
        this.isDefault = false;
      }

      if (
        this.displayableAges.some(
          (displayableAge) =>
            displayableAge[0] === parsedAge[0] &&
            displayableAge[1] === parsedAge[1]
        )
      ) {
        this.displayableAges = this.displayableAges.filter(
          (displayableAge) =>
            displayableAge[0] !== parsedAge[0] ||
            displayableAge[1] !== parsedAge[1]
        );
      } else {
        this.displayableAges.push(parsedAge);
      }
    }

    this.setupChart();
  }
}
